import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {NgForm, FormBuilder, FormGroup, FormControl} from '@angular/forms';

@Component({
  selector: 'app-assign-team',
  templateUrl: './assign-team.component.html',
  styleUrls: ['./assign-team.component.css']
})
export class AssignTeamComponent implements OnInit {
  public teams: any;
  public selectedTeam: any;
  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<AssignTeamComponent>) { }

  ngOnInit() {
    if (this.data != null ) {
      this.teams = this.data.teams;
      console.log(this.teams);
    }
  }
  cancel() {
    this.dialogRef.close('Cancel');
  }
  proceed() {
    console.log(this.selectedTeam.teamDetail);
    this.dialogRef.close( this.selectedTeam);
  }

}
